import {CustomTextField} from '../../../components/CustomTextField';
import {CustomSelect} from '../../../components/CustomSelect';
import {CustomDatePicker} from '../../../components/CustomDatePicker';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {gender, GENDER_MODEL} from '../../../enums/genderEnum';
import {useParams} from "react-router-dom";
import {InputAdornment} from "@mui/material";
import {DOCUMENT_ID_MIN_LENGTH} from "../../../constant/variable";
import {FolderPerson, InfoChip} from "../../../components/buttons/IconButtons";
import CustomUserChip from "../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../Helpers/PositionModel";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model modifiedData: model to data
 */
const FieldsValidation = ({modifiedData, handleChange, isValidDocumentId, validateDocumentIdChanges }) => {
    const { t } = useTranslation();
    const { guardFlowId } = useParams();

    const genderList = Object.entries(gender)
        .filter(([key]) => parseInt(key) !== GENDER_MODEL.OTHER.id)
        .map(([key, value]) => ({
            id: Number(key),
            name: t(value),
        }));

    return (
        <>
            <div className="d-flex flex-column gap-2">
                { guardFlowId ?
                    <>
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950">{t("thank_you_for_submitting_visitors_photo")}</p>
                        <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950">{t("the_photo_has_been_submitted_successfully")}</p>
                    </>
                    :
                    <>
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950">{t("thank_you_for_submitting_your_photo")}</p>
                        <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950">{t("if_you_find_any_errors_you_can_edit_the_details_otherwise_click_confirm_to_proceed")}</p>
                    </>
                }
            </div>
            <div className="row mt-4 py-0">
                <div className="col-12">
                    <CustomTextField
                        id={'txt_fv_name'}
                        name={'name'}
                        value={modifiedData.name}
                        trans={'name'}
                        type={'text'}
                        onChange={handleChange}
                        required={true}
                    />
                </div>
                <div className="col-12">
                    <CustomTextField
                        id={'txt_fv_last_name'}
                        name={'lastName'}
                        value={modifiedData.lastName}
                        trans={'last_name'}
                        type={'text'}
                        onChange={handleChange}
                        required={true}
                    />
                </div>
                <div className="col-12">
                    <CustomTextField
                        id={'txt_fv_second_last_name'}
                        name={'secondLastName'}
                        value={modifiedData.secondLastName}
                        trans={'second_last_name'}
                        type={'text'}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12">
                    <CustomSelect
                        id={'slt_fv_gender'}
                        name={'gender'}
                        value={modifiedData.gender}
                        key={modifiedData.gender}
                        keyName='id'
                        onChange={handleChange}
                        list={genderList}
                        trans={'gender'}
                        label={'lbl_fv_gender_id'}
                        showNoSelectionOption={false}
                        required={true}
                    />
                </div>
                <div className="col-12">
                    <CustomDatePicker
                        id={'dp_fv_dob'}
                        name={'dob'}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'dob' } });
                        }}
                        trans={'dob'}
                        value={modifiedData.dob}
                        disableFuture={true}
                        openTo={'year'}
                        required={true}
                    />
                </div>

                <div className='col-12 mb-4'>
                    <CustomTextField
                        id={'txt_fv_document_id'}
                        length={DOCUMENT_ID_MIN_LENGTH}
                        name={'documentId'}
                        value={modifiedData.documentId}
                        trans={'documentId'}
                        type={'text'}
                        onChange={validateDocumentIdChanges}
                        isValid={isValidDocumentId}
                        isValidText={t('must_have_the_same_length_as_the_original', { length: modifiedData?.documentIdOriginal?.length})}
                        required={true}
                        disabled={modifiedData?.maxChanges === 0}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position='end'>
                                    <FolderPerson />
                                </InputAdornment>
                            ),
                        }}
                        autoComplete={'off'}
                        marginBottom={true}
                    />
                    <CustomUserChip
                        className={"mt-0 w-100 chip-secondary-100"}
                        name={t("document_can_only_be_modified_up_to_x_times", {
                            maxDeletes: modifiedData?.maxDeletes,
                            maxChanges: modifiedData?.maxChanges })}
                        Icon={InfoChip}
                        showAvatar={true}
                        classNameIcon={"icon-color-secondary-700"}
                        classNameText={"font-color-secondary-700"}
                        iconPosition={POSITION_MODEL.LEFT}
                    />
                </div>
            </div>
        </>
    );

}

export default FieldsValidation
